export default {
  name: '暗',
  style: {
    color_base: '200, 200, 200',
    color_back_base: '0, 0, 0',
    alpha_slight: '.03'
  }
};
